import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { FlexColumn, Select as BaseSelect } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useClientBranchCostCenters from '@ubeya/shared/hooks/account/useClientBranchCostCenters';
import { CostCentersSection } from 'shared/components';

const Wrapper = styled(FlexColumn)`
  flex: 1;
  padding: 31px 50px;
  overflow: auto;
  .loader {
    z-index: 1;
  }

  .settings-page-content {
    padding: 10px 0;
  }

  .settings-page-title-row {
    padding: 20px 0;
  }
`;

const Select = styled(BaseSelect)`
  > .select {
    width: 300px;

    .select-label {
      line-height: 14px;
      max-width: 95%;
    }

    .select-input {
      min-height: 24px;
      padding: 5px 10px;
    }

    .select-arrow {
      right: 12px;
    }
  }
`;

const ClientCardCostCentersTab = ({ clientId, clientBranches = [] }) => {
  const { t } = useContext(ConfigContext);

  const clientBranchesOptions = (clientBranches || []).map(({ id, name }) => ({ value: id, label: name }));
  const [selectedClientBranch, setSelectedClientBranch] = useState(clientBranchesOptions?.[0]?.value || null);

  const {
    branchCostCenters,
    isLoading,
    addClientBranchCostCenter,
    updateClientBranchCostCenter
  } = useClientBranchCostCenters({
    clientId,
    clientBranchId: selectedClientBranch
  });

  const showClientBranchPicker = clientBranchesOptions.length > 1;

  return (
    <Wrapper>
      {showClientBranchPicker && (
        <Select
          title={t('clientBranch')}
          options={clientBranchesOptions}
          isMulti={false}
          usePortal
          value={selectedClientBranch}
          onChange={setSelectedClientBranch}
        />
      )}

      <CostCentersSection
        costCenters={branchCostCenters}
        isLoading={isLoading}
        addCostCenter={addClientBranchCostCenter}
        updateCostCenter={updateClientBranchCostCenter}
      />
    </Wrapper>
  );
};

export default ClientCardCostCentersTab;
